import { styled } from "webapp/styled-components";

export const SwipeStackStyle = styled.div`
    position: relative;
    flex-grow: 1;

    display: grid; // stops safari from squishing for no obvious reason

    > .grid {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;

        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 100%;

        padding: ${p => p.theme.componentSmallInnerVerticalPadding}px ${p => p.theme.pageMarginMedium}px;

        > .card {
            display: flex;
            flex-direction: column;

            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);

            padding: 16px 0;

            border-radius: 8px;

            grid-column: 1;
            grid-row: 1;

            background-color: ${p => p.theme.baseColor};

            border: 1px solid ${p => p.theme.separatorColor};

            min-height: 0;
            height: 100%;

            overflow-y: auto;

            ::-webkit-scrollbar {
                display: none;
            }
        }

        > .front {
            z-index: 1;
        }
    }
`;
